import React from 'react'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'
import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './SomethingWentWrongModal.scss'


const SomethingWentWrongModal = composeDialogModal({
  name: constants.modals.SomethingWentWrong,
  title: messages.title,
  buttonTitle: messages.buttonTitle,
  content: () => (
    <div className={s.content} data-testid={constants.testIds.modal.somethingWentWrongModal}>
      <FormattedMessage {...messages.text} />
      &nbsp;<Link mailto="support@scentbird.com" />
    </div>
  ),
})


export default SomethingWentWrongModal
